import React from "react";
import TableView from "@/common/components/TableView/TableView";
import { Grid, Button } from "@mui/material";
import { PlusOutlined } from "@ant-design/icons";
import { columns, reportFileName } from "./constants/constants";
import CreateEditDropdownListMaster from
    "./create-dropdownlist-master/create-dropdownlist-master";
import ModalDialog from "@/common/components/modal-dialog/modal-dialog";
import useDropdownListMaster from "./hooks/useDropdownListMaster";
import { FormattedMessage } from "react-intl";
import useOnActions from "./hooks/useOnActions";
import AlertDialog from "@/common/components/alert-dialog/alert-dialog";
import VerifyAccess from "@/common/components/verify-access/verify-access";
import { requestedMenuAll, requestedFeaturesAll } from "@/from-theme/routes/constants/menuAccess";
import { isUserHasAccess } from "@/from-theme/utils/route-guard/helpers/helpers";
import useAuth from "@/from-theme/hooks/useAuth";

const {dropdownListTabMasterKey} = requestedMenuAll;
const {createKey, updateKey, deleteKey} = requestedFeaturesAll;

export default function Dropdownlist() {
    const { dropdownlistMasterData, isCreateEditModalOpen, setIsCreateEditModalOpen, onRowEdit,
        activeEditId, closeModal, dropdownlistMasterStatus, dropdownlistMasterErrMsg }
        = useDropdownListMaster();
        const { userData } = useAuth();
        const entitlement = userData?.entitlement || {};
      
        const isUpdateDeleteAccess = 
        isUserHasAccess(dropdownListTabMasterKey, updateKey, entitlement)
          || isUserHasAccess(dropdownListTabMasterKey, deleteKey, entitlement);        
    const {
        onRowDelete,
        deleteDropdownlistMasterStatus,
        isAlertDialog,
        onCloseAlert,
        onAgreeAlert
    } = useOnActions();
    const actionButton = (
    <VerifyAccess requestedMenu={dropdownListTabMasterKey} requestedFeature={createKey}>
        <Button
            variant="contained"
            startIcon={<PlusOutlined />}
            onClick={() => setIsCreateEditModalOpen(true)}
        ><FormattedMessage id="add-dropdown-list" />
        </Button>
    </VerifyAccess>

    );

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <TableView
                    data={dropdownlistMasterData}
                    columns={columns({ onRowEdit, onRowDelete, deleteDropdownlistMasterStatus,
                        isUpdateDeleteAccess })}
                    actionButton={actionButton}
                    reportFileName={reportFileName}
                    apiStatus={dropdownlistMasterStatus}
                    apiErrorMsg={dropdownlistMasterErrMsg}
                    stringInExport={["activeStatus"]}
                />
                {isCreateEditModalOpen && (
                    <ModalDialog
                        closeModal={() => closeModal()}
                        modalTitle={!activeEditId ? "create-dropdownlist-master" :
                         "edit-dropdownlist-master"}
                    >
                        <CreateEditDropdownListMaster closeModal={() => closeModal()}
                            activeEditId={activeEditId} />
                    </ModalDialog>
                )}
                {isAlertDialog && (
                    <AlertDialog onCloseAlert={onCloseAlert} onAgreeAlert={onAgreeAlert} />
                )}
            </Grid>
        </Grid>
    );
}
